import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { MdInfoOutline } from "react-icons/md";
import { Banner } from "../../components/mui";
import PasswordChangeForm from "../../components/auth/PasswordChangeForm";

/**
 * 改密碼（設計稿 #screen-password，el-pm-template_4.html:2243-2271）
 *
 * 舊系統這件事是側欄左下角一個 16px 的小鎖頭彈窗 —— 圖示沒有文字、命中區
 * 不到 44px，而且開在遮罩上，一按到旁邊就整個關掉、打到一半的內容全沒了。
 * 改成獨立的一整頁：有網址、可以從「我的帳號」與「設定」兩個地方進來，
 * 按錯地方也不會消失。
 *
 * components/auth/ChangePasswordDialog.js **保留不刪**（硬規則 8），但別被它騙了：
 * 全專案已經沒有任何檔案 import 它。原本唯一的使用者是舊側欄
 * （5c988b5:src/layouts/commons/Sider.js 第 8、387 行），而改寫後的側欄
 * 已經把改密碼搬到這一頁（見 Sider.js 檔頭）。其他幾處提到它的都只是註解，
 * 談的是 portal / ESC 的作法，不是在用那支元件。
 *
 * 表單本體（欄位、規則、送出）在 components/auth/PasswordChangeForm，
 * 「設定 → 我的帳號」也用同一份。密碼規則 checkPassword 也在那裡；
 * ChangePasswordDialog.js、Setting/AdminEdit.js 各還有一份相同規則，改規則要一起改。
 */

function MePassword() {
  const navigate = useNavigate();

  return (
    <>
      <Typography variant="h1" component="h1">
        變更密碼
      </Typography>

      {/*
        後果先講（硬規則 4）。

        設計稿 L2245 寫的是「改完之後這台電腦不用重新登入，其他裝置會被登出」，
        但這套系統的登入憑證是 JWT，後端改密碼只換掉資料庫裡的雜湊值，
        **不會**讓已經發出去的憑證失效 —— 其他裝置上開著的畫面要等它自己的
        登入時效到期才會被擋下來。照設計稿原文寫會變成一句聽起來很安心、
        實際上不成立的保證，所以這裡照實際行為寫（硬規則 10）。
        後端補上憑證撤銷之後，這段文字就可以換回設計稿的版本。
      */}
      <Banner kind="info" icon={<MdInfoOutline />} sx={{ mt: "var(--space-3)", maxWidth: 560 }}>
        變更後，此裝置無須重新登入。
        其他已登入的裝置不會立即登出，須待其登入時效到期；
        若密碼可能已外洩，請一併聯絡資訊室（分機 168）。
      </Banner>

      <Card sx={{ mt: "var(--space-6)", maxWidth: 560 }}>
        <CardContent>
          {/* 表單本體與「設定 → 我的帳號」共用（components/auth/PasswordChangeForm） */}
          <PasswordChangeForm idPrefix="pw" onSuccess={() => navigate("/Me")} onCancel={() => navigate("/Me")} />
        </CardContent>
      </Card>
    </>
  );
}

export default MePassword;
